<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <Breadcrumbs headline="Sổ ghi đầu bài" :link="[{ text: 'Sổ ghi đầu bài', href: '/teacherClassNotes' }]" />
    </div>

    <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
      <v-row>
        <v-col cols="12" sm="12" md="10">
          <v-form ref="form">
            <v-row>
              <v-col cols="12" md="4">
                <DateIOSPicker
                  label="Ngày"
                  :date.sync="time"
                  outlined
                  :rules="[$rules.date, $rules.dateFromNow]"
                  dense
                />
              </v-col>
              <!-- <v-col cols="12" md="4">
                <AutocompleteSubjectGroup
                  return-object
                  item-text="title"
                  item-value="id"
                  label="Bộ môn"
                  deletable-chips
                  dense
                  required
                  outlined
                  v-model="subjectGroup"
                />
              </v-col> -->
            </v-row>
          </v-form>
        </v-col>

        <v-col class="d-flex align-start" cols="12" sm="12" md="2">
          <v-btn outlined class="search-button" @click="search">Tìm kiếm</v-btn>
        </v-col>
      </v-row>
    </v-card>

    <!-- table -->
    <v-card outlined class="mx-4 mb-6 elevation-0">
      <v-data-table
        loading-text="Đang Tải"
        :headers="headers"
        :items="slots"
        :loading="loading"
        :footer-props="{
          'items-per-page-text': 'Hiển thị mỗi trang',
          'items-per-page-all-text': 'Tất cả',
          'items-per-page-options': slots.length > 100 ? [10, 20, 30] : [10, 30, -1]
        }"
      >
        <template v-slot:[`item.class`]="{ item }">
          <router-link style="text-decoration: none" :to="'/class/' + (item.class && item.class.id)">
            {{ item | _get('class.title') }}
          </router-link>
        </template>
        <template v-slot:[`item.subject`]="{ item }">
          <div v-if="$_get(item, 'classNote.metadata.slot.subject.title')">
            <!-- đã ghi -->
            {{ item | _get('classNote.metadata.slot.subject.title') }}
          </div>
          <div v-else>
            <!-- chưa ghi -->
            {{ item | _get('subject.title') }}
          </div>
        </template>
        <template v-slot:[`item.classNote.lesson`]="{ item }">
          <div :class="$_get(item, 'classNote.lesson', '').includes('Chưa có thông tin') ? 'red--text' : ''">
            {{ item | _get('classNote.lesson') }}
          </div>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <div v-if="isToday">
            <v-chip class="mr-2" small label color="#46BE8A" dark>
              Đang diễn ra
            </v-chip>
            <v-chip v-if="!$_get(item, 'classNote.noted')" small label color="orange" dark
              ><span>
                Chưa ghi
              </span>
            </v-chip>
            <v-chip v-else small label :color="$_get(item, 'classNote.status') === 'on-time' ? `#46BE8A` : `blue`" dark
              ><span>
                {{ $_get(item, 'classNote.status') === 'on-time' ? `Đã ghi` : `Ghi muộn` }}
              </span>
            </v-chip>
          </div>
          <div v-else>
            <v-chip class="mr-2" small label color="grey" dark>
              Đã diễn ra
            </v-chip>
            <v-chip v-if="!$_get(item, 'classNote.noted')" small label color="red" dark
              ><span>
                Chưa ghi
              </span>
            </v-chip>
            <v-chip v-else small label :color="$_get(item, 'classNote.status') === 'on-time' ? `#46BE8A` : `blue`" dark
              ><span>
                {{ $_get(item, 'classNote.status') === 'on-time' ? `Đã ghi` : `Ghi muộn` }}
              </span>
            </v-chip>
          </div>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <span style="cursor: pointer" @click="goToDetail(item)">
            <v-icon color="primary">mdi-pencil</v-icon>
          </span>
          <!-- <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon>
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item style="cursor: pointer" @click="goToDetail(item)">
                <v-list-item-title>Ghi sổ</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu> -->
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import { mapState, mapGetters, mapActions } from 'vuex'
import DateIOSPicker from '@/components/basic/picker/DateIOSPicker.vue'
// import AutocompleteSubjectGroup from '@/components/basic/input/AutocompleteSubjectGroup'
import moment from 'moment'
import { get, orderBy } from 'lodash'
import { ClassNote } from '../../plugins/api'

export default {
  components: {
    Breadcrumbs,
    DateIOSPicker
    // AutocompleteSubjectGroup
  },
  data() {
    return {
      headers: [
        {
          text: 'Lớp',
          value: 'class',
          align: 'left',
          sortable: false
        },
        {
          text: 'Tiết',
          value: 'index',
          align: 'left',
          sortable: false
        },
        {
          text: 'Môn học',
          value: 'subject',
          align: 'left',
          sortable: false
        },
        {
          text: 'Tiết theo PPCT',
          value: 'classNote.data.lessonIndex',
          align: 'left',
          sortable: false
        },
        {
          text: 'Đầu bài/ nội dung',
          value: 'classNote.lesson',
          align: 'left',
          sortable: false
        },
        {
          text: 'Trạng thái',
          value: 'status',
          align: 'left',
          sortable: false
        },
        {
          text: 'Thao tác',
          value: 'actions',
          align: 'left',
          sortable: false
        }
      ],
      time: moment().toISOString(),
      subjectGroup: '',
      selectedTeacherId: '',
      loading: false,
      slots: [],
      moment: moment
    }
  },
  watch: {},
  computed: {
    ...mapState('ClassNotes', ['classSlots', 'teacherSlots']),
    ...mapGetters('auth', ['profile', 'role']),
    ...mapState('ClassNoteDetail', ['date']),

    isTeacherUser() {
      return this.role.type === 'teacher'
    },
    isToday() {
      return moment(this.date).isSame(moment().startOf('day'))
    }
  },
  async mounted() {
    if (this.isTeacherUser) {
      const day = moment().day()
      this.selectedTeacherId = this.profile.id
      this.setSelectedTeacherId(this.selectedTeacherId)
      this.setDate(
        moment(this.time)
          .startOf('day')
          .toISOString()
      )

      this.loading = true
      await this.fetchTeacherSlots({ teacher: this.selectedTeacherId, day })
      await this.fetchHistoryClassNotes({
        teacher: this.selectedTeacherId,
        day,
        date: this.date
      })
      this.mappingSlots()
      this.loading = false
    }
  },
  methods: {
    ...mapActions('ClassNotes', ['fetchTeacherSlots', 'setSelectedTeacherId', 'fetchHistoryClassNotes']),
    ...mapActions('ClassNoteDetail', ['setDate']),

    async search() {
      if (!this.$refs.form.validate()) return

      this.loading = true

      this.setDate(
        moment(this.time)
          .startOf('day')
          .toISOString()
      )
      const day = moment(this.time).day()
      await this.fetchTeacherSlots({
        teacher: this.selectedTeacherId,
        'subject.subjectGroup': get(this.subjectGroup, 'id'),
        day
      })
      await this.fetchHistoryClassNotes({
        teacher: this.selectedTeacherId,
        day,
        date: moment(this.time)
          .startOf('day')
          .toISOString()
      })
      this.mappingSlots()
      this.loading = false
    },

    async mappingSlots() {
      let slots = []
      for (const slot of Object.values(this.teacherSlots)) {
        if (!get(slot, 'classNote.id')) {
          let classNote = slot.classNotes.find(classNote => classNote.date === this.time)
          if (classNote && classNote.id) {
            classNote = await ClassNote.fetchOne(classNote.id)
            if (
              classNote.lesson &&
              get(classNote, 'data.lessonIndex') &&
              get(classNote, 'data.classMark') &&
              get(classNote, 'data.classComment')
            ) {
              classNote.noted = true
            }
          }

          slot.classNote = classNote
        } else {
          if (
            slot.classNote.lesson &&
            get(slot.classNote, 'data.lessonIndex') &&
            get(slot.classNote, 'data.classMark') &&
            get(slot.classNote, 'data.classComment')
          ) {
            slot.classNote.noted = true
          }
        }

        slots.push(slot)
      }

      // let slots = Object.values(this.teacherSlots).map(slot => {
      //   const classNote = slot.classNotes.find(classNote => classNote.date === this.time)
      //   if (
      //     classNote &&
      //     (classNote.lesson ||
      //       get(classNote, 'data.lessonIndex') ||
      //       get(classNote, 'violations.length') ||
      //       get(classNote, 'marks.length') ||
      //       get(classNote, 'data.classMark') ||
      //       get(classNote, 'data.classComment'))
      //   ) {
      //     classNote.noted = true
      //   }
      //   slot.classNote = classNote
      //   return slot
      // })

      slots = orderBy(slots, ['index', ['asc']])
      this.slots = slots
    },
    goToDetail(item) {
      this.$router.push(`/classNoteDetail/${item.id}/${this.time}`)
    }
  }
}
</script>

<style lang="scss" scoped></style>
